import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { CardTokenComponent } from './components/card-token/card-token.component';

const routes: Routes = [
  { 
    path: '', 
    component: CardTokenComponent,
  },
  { path: 'card-token', component: CardTokenComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
